angular.module('picmonic-common').directive('videoModal', function () {
  return {
    restrict: 'A',
    scope: {
      videoId: '@videoModal',
      videoUrl: '@videoUrl',
      title: '@title',
    },
    controller: [
      '$scope',
      '$modal',
      function ($scope, $modal) {
        var videoId = $scope.videoId,
          videoUrl = $scope.videoUrl,
          title = $scope.title;
        $scope.openModal = function () {
          $modal.open({
            templateUrl: '/templates/modals/video-modal.html',
            windowClass: 'learn-light-modal video-modal',
            keyboard: true,
            controller: [
              '$scope',
              function ($scope) {
                $scope.videoId = videoId;
                $scope.videoUrl = videoUrl;
                $scope.title = title;
                $scope.playerVars = {
                  autoplay: 1,
                  controls: 2,
                  color: 'white',
                  fs: 0,
                  modestbranding: 1,
                  rel: 0,
                };
              },
            ],
          });
        };
      },
    ],
    link: function (scope, element, attrs) {
      element.bind('click', function () {
        scope.$apply(function () {
          scope.openModal();
        });
      });
    },
  };
});
